import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { CATEGORIES, byCategory } from "../../data/salon";
import { toFa } from "../../lib/format";
import { useStagger } from "../../lib/motion";
import { SectionHead } from "../ui/Bits";

export default function Categories() {
  const grid = useStagger({ step: 70 });

  return (
    <section className="section section--defer cats">
      <div className="wrap wrap--wide">
        <SectionHead
          eyebrow="CATEGORIES"
          title="از کجا <em>شروع</em> کنیم؟"
          lede="پنج حوزه تخصصی، هر کدام با تیم و پروتکل مخصوص خودش."
          to="/services"
          toLabel="همه خدمات"
        />

        <div className="cats__mosaic" ref={grid}>
          {CATEGORIES.map((c, i) => (
            <Link
              key={c.slug}
              to={`/services?c=${c.slug}`}
              className={`ctile ctile--${i} reveal`}
              data-stagger=""
            >
              <Photo src={c.photo} ratio="4 / 5" tint="dusk" className="ph--hover ctile__ph" />

              <span className="ctile__body">
                <span className="eyebrow eyebrow--light">{c.latin}</span>
                <span className="ctile__name">{c.label}</span>
                <span className="ctile__blurb">{c.blurb}</span>
                <span className="ctile__count">{toFa(byCategory(c.slug).length)} خدمت</span>
              </span>

              <span className="ctile__arrow" aria-hidden="true">←</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
